import { WarehousesActionTypes } from './constants';

export const INIT_STATE = {
    loadingWarehouses: false,
    error: null,
    warehouses: null,
    creatingWarehouse: false,
    createdWarehouse: null,
    deletingWarehouse: false,
    deletedWarehouse: false,
    updatingWarehouse: false,
    updatedWarehouse: null,
    initialWarehouse: {
        description: null,
        name: null,
        companyName: null,
        email: null,
        phone: null,
        street1: null,
        street2: null,
        street3: null,
        stateProvince: null,
        postalCode: null,
        cityLocality: null,
        countryCode: null,
    },
};

type WarehousesAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};

//TODO: define data type for orders
type State = {
    loadingAddresses: Boolean,
    error?: null,
    addresses: any,
    creatingWarehouse: Boolean,
    createdWarehouse: any,
    deletingWarehouse: Boolean,
    deletedWarehouse: Boolean,
    updatingWarehouse: Boolean,
    updatedWarehouse: any,
    initialWarehouse: any,
};

const Warehouses = (state: State = INIT_STATE, action: WarehousesAction): any => {
    switch (action.type) {
        case WarehousesActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case WarehousesActionTypes.READ_ALL_WAREHOUSES_REQUEST: {
                    return { ...state, loadingWarehouses: false, warehouses: action.payload.data };
                }
                case WarehousesActionTypes.CREATE_WAREHOUSE_REQUEST: {
                    return { ...state, creatingWarehouse: false, createdWarehouse: action.payload.data };
                }
                case WarehousesActionTypes.DELETE_WAREHOUSE_REQUEST: {
                    return { ...state, deletingWarehouse: false, deletedWarehouse: true };
                }
                case WarehousesActionTypes.UPDATE_WAREHOUSE_REQUEST: {
                    return { ...state, updatingWarehouse: false, updatedWarehouse: action.payload.data };
                }
                default:
                    return { ...state, loadingWarehouses: false, warehouses: null, error: null, creatingWarehouse: false, createdWarehouse: null, deletingWarehouse: false, deletedWarehouse: false, updatingWarehouse: false, updatedWarehouse: null };
            }

        case WarehousesActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case WarehousesActionTypes.READ_ALL_WAREHOUSES_REQUEST: {
                    return { ...state, loadingWarehouses: false, error: action.payload.error };
                }
                case WarehousesActionTypes.CREATE_WAREHOUSE_REQUEST: {
                    return { ...state, creatingWarehouse: false, error: action.payload.error };
                }
                case WarehousesActionTypes.DELETE_WAREHOUSE_REQUEST: {
                    return { ...state, deletingWarehouse: false, error: action.payload.error };
                }
                case WarehousesActionTypes.UPDATE_WAREHOUSE_REQUEST: {
                    return { ...state, updatingWarehouse: false, error: action.payload.error };
                }
                default:
                    return { ...state };
            }

        case WarehousesActionTypes.READ_ALL_ADDRESSES_REQUEST:
            return { ...state, loadingAddresses: true, addresses: null };
        case WarehousesActionTypes.CREATE_WAREHOUSE_REQUEST:
            return { ...state, creatingWarehouse: true, createdWarehouse: null };
        case WarehousesActionTypes.DELETE_WAREHOUSE_REQUEST:
            return { ...state, deletingWarehouse: true, deletedWarehouse: false };
        case WarehousesActionTypes.UPDATE_WAREHOUSE_REQUEST:
            return { ...state, updatingWarehouse: true, updatedWarehouse: null };
        case WarehousesActionTypes.RESET_STATE:
            return { ...state, warehouses: null, error: null, creatingWarehouse: false, createdWarehouse: null, deletingWarehouse: false, deletedWarehouse: false, updatingWarehouse: false, updatedWarehouse: null };
        case WarehousesActionTypes.RESET_ALL_ERRORS:
            return { ...state, error: null };
        default:
            return { ...state };
    }
};

export default Warehouses;
